import Hero from "../../components/Hero/Hero";
import AddMovieForm from "../../components/AddMovieForm/AddMovieForm";

const CreateMovie = () => {
    return (
        <>
           <Hero />
           <AddMovieForm />
        </>
    );
}

export default CreateMovie;